function setJPCookie(name, value, days) {
  // Set the expiration date for the cookie
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // days to milliseconds
  const expires = "; expires=" + date.toUTCString();
  document.cookie = name + "=" + value + expires + "; path=/";
}

function getJPCookie(name) {
  // Parse document.cookie and return the value of the requested cookie
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
    if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
  }
  return null;
}

function redirectToMomentFactory() {
  const currentUrl = window.location.href;

  // Check if the URL contains any of the specified paths
  const containsJapanPath = currentUrl.includes('/en-jp') || currentUrl.includes('/fr-jp') || currentUrl.includes('/ja-jp');

  // Check if the "japan-preview=true" parameter exists in the URL
  const urlParams = new URLSearchParams(window.location.search);
  const japanPreview = urlParams.get('japan-preview');

  // Check if the cookie preventing the redirect exists
  const previewCookie = getJPCookie('japanPreviewCookie');

  // If "japan-preview=true" is in the URL, set the cookie to prevent redirects for 2 days
  if (japanPreview === 'true') {
    setJPCookie('japanPreviewCookie', 'true', 2); // Set cookie for 2 days
  }

  // Redirect if the URL contains any of the specified paths, and the cookie is not set
  if (!japanPreview) {
    if (containsJapanPath && !previewCookie) { 
      // window.location.href = 'https://momentfactory.com/';
    }
  }
}

// Call the function to check and possibly redirect
redirectToMomentFactory();
